import React, { useState } from "react"
import { Button, Card, Result, MinimalShell } from "@mimber/ui-web"
import { JoinWaitlistForm } from "@/components/forms/JoinWaitlistForm"
import { SubmitInviteCodeForm } from "@/components/forms/SubmitInviteCodeForm"
import { useAuth } from "@/core/contexts"
import type { BetaAccessGateProps } from "./BetaAccessGate.types"

const INVITE_CODE_KEY = "mimber_invite_code"

export const BetaAccessGate: React.FunctionComponent<BetaAccessGateProps> = ({
  userData,
  onRetryLogin,
}) => {
  const { logout } = useAuth()
  const [showWaitlistForm, setShowWaitlistForm] = useState(false)
  const [showInviteCodeForm, setShowInviteCodeForm] = useState(false)
  const [waitlistJoined, setWaitlistJoined] = useState(false)

  const storedInviteCode = localStorage.getItem(INVITE_CODE_KEY) ?? undefined

  return (
    <MinimalShell>
      <Card>
        {waitlistJoined ? (
          <Result
            status="success"
            title="You're on the Waitlist!"
            subTitle="We'll notify you when your account is ready. Keep an eye on your inbox."
          />
        ) : showInviteCodeForm ? (
          <div>
            <SubmitInviteCodeForm
              defaultInviteCode={storedInviteCode}
              onSuccess={onRetryLogin}
            />
            <div className="mt-4 text-center">
              <Button
                type="link"
                onClick={() => {
                  setShowInviteCodeForm(false)
                  setShowWaitlistForm(true)
                }}
              >
                Don&apos;t have a code? Join the waitlist
              </Button>
            </div>
          </div>
        ) : showWaitlistForm ? (
          <div>
            <JoinWaitlistForm
              onSuccess={() => setWaitlistJoined(true)}
              defaultEmail={userData?.email}
              defaultName={
                userData?.firstName && userData?.lastName
                  ? `${userData.firstName} ${userData.lastName}`
                  : undefined
              }
            />
            <div className="mt-4 text-center">
              <Button
                type="link"
                onClick={() => {
                  setShowWaitlistForm(false)
                  setShowInviteCodeForm(true)
                }}
              >
                Have an invite code?
              </Button>
            </div>
          </div>
        ) : (
          <Result
            status="info"
            title="Beta Access Required"
            subTitle="Mimber is currently in private beta. Join our waitlist to get early access."
            extra={
              <div className="flex flex-col gap-2">
                <Button
                  type="primary"
                  onClick={() => setShowInviteCodeForm(true)}
                >
                  I Have an Invite Code
                </Button>
                <Button onClick={() => setShowWaitlistForm(true)}>
                  Join Waitlist
                </Button>
              </div>
            }
          />
        )}
        <div className="mt-4 text-center">
          <Button type="link" size="small" onClick={() => logout()}>
            Log out
          </Button>
        </div>
      </Card>
    </MinimalShell>
  )
}
